import axios from "axios";
import { BioSuisseService } from "./service";
import { keycloak } from "../../../../lib/keycloak";
import { CertBioSuisseResponseDTO, CreateCertBioSuisseDTO, EditCertBioSuisseDTO, GetAllCertificatesFiltersDTO } from "./dto";
import { filter } from "jszip";

export class BioSuisseServiceImpl implements BioSuisseService {

    public GetAllBioSuisse(filters: GetAllCertificatesFiltersDTO): Promise<CertBioSuisseResponseDTO> {
        return axios.get("/api/bio-suisse", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                order: filters.order,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                customerId: filters.customerId,
                idCertificatoDemeter: filters.idCertificatoDemeter
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET", 
            }
        }).then((response) => response.data)
    }

    // CREATE
    public CreateBioSuisse(data: CreateCertBioSuisseDTO): Promise<void> {
        return axios.post("/api/bio-suisse",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public UpdateBioSuisse(body: EditCertBioSuisseDTO, id: string): Promise<void> {
        return axios.put("/api/bio-suisse/" + id,
            body,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

}